import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { fmtChips } from "../../lib/api";
import { sounds } from "../../lib/sounds";

const SHOW_MS = 10000;

// Overlay on the table that just hit: rotating gold rays, coin & confetti shower, double gold frame, shimmering headline.
export const JackpotBanner = ({ event, onDone }) => {
  const [bits] = useState(() => Array.from({ length: 70 }, (_, i) => ({
    id: i, x: Math.random() * 100, d: 2 + Math.random() * 2.2, delay: Math.random() * 1.6, coin: i % 3 === 0,
    hue: [43, 48, 36, 0][i % 4], sway: (Math.random() - 0.5) * 120,
  })));
  useEffect(() => {
    if (!event) return;
    sounds.jackpot();
    const t = setTimeout(onDone, SHOW_MS);
    return () => clearTimeout(t);
  }, [event, onDone]);
  if (!event) return null;
  return (
    <div data-testid="jackpot-banner" className="absolute inset-0 z-50 flex items-center justify-center pointer-events-none overflow-hidden">
      <div className="absolute inset-0 bg-black/45 jackpot-dim" />
      <div className="jackpot-rays" aria-hidden />
      {bits.map((b) => (
        <span key={b.id} className={b.coin ? "jackpot-coin" : "jackpot-confetti"}
          style={{ left: `${b.x}%`, animationDuration: `${b.d}s`, animationDelay: `${b.delay}s`, "--sway": `${b.sway}px`, background: b.coin ? undefined : `hsl(${b.hue} 90% ${b.hue ? 55 : 45}%)` }} />
      ))}
      <div className="jackpot-burst relative">
        <div className="jackpot-frame-outer rounded-3xl p-[3px]">
          <div className="jackpot-frame-inner rounded-[21px] px-12 py-8 text-center">
            <div className="flex items-center justify-center gap-3 font-display tracking-[0.5em] text-amber-300 text-sm">
              <Trophy className="w-6 h-6 jackpot-wobble" /> <span className="jackpot-shimmer">JACKPOT</span> <Trophy className="w-6 h-6 jackpot-wobble" style={{ animationDelay: "0.3s" }} />
            </div>
            <div className="font-display text-xs tracking-[0.3em] text-amber-200/70 mt-3">{event.jackpot_name?.toUpperCase()}</div>
            <div className="font-display text-3xl md:text-4xl text-amber-50 mt-2 jackpot-shimmer" data-testid="jackpot-banner-winner">{event.winner.name}</div>
            <div className="font-mono text-5xl md:text-6xl text-amber-200 mt-3 jackpot-digits jackpot-pop">{fmtChips(event.winner.amount)}</div>
            <div className="text-sm text-amber-100/90 mt-4" data-testid="jackpot-banner-text">{event.message}</div>
            {event.shares?.length > 0 && (
              <div className="text-xs text-slate-300 mt-3" data-testid="jackpot-banner-shares">Table share: {event.shares.map((s) => `${s.name} ${fmtChips(s.amount)}`).join(" · ")}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
